import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Label + control + inline error, used by every field in both booking forms so the
 * customer page and the admin modal report problems the same way.
 */
const FormField = ({ label, htmlFor, required = false, hint, error, children, className = '' }) => (
  <div className={className}>
    {label && (
      <label htmlFor={htmlFor} className="block text-sm font-medium text-midnight-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
    )}
    {children}
    {error ? (
      <p className="mt-1.5 flex items-start gap-1.5 text-xs text-red-600">
        <AlertCircle className="w-3.5 h-3.5 flex-shrink-0 mt-px" />
        <span>{error}</span>
      </p>
    ) : (
      hint && <p className="mt-1.5 text-xs text-midnight-500">{hint}</p>
    )}
  </div>
);

/** Border treatment shared by every input, so an invalid field looks the same everywhere. */
export const fieldClass = (hasError, extra = '') =>
  `input-field ${hasError ? 'border-red-400 focus:border-red-500 focus:ring-red-500/20' : ''} ${extra}`.trim();

export default FormField;
